<template>
        <div class="reviews-layout master-section">
            <section class="row align-items-center text-md-left px-0 px-md-1 mb-md-60px mb-40px mx-0 mx-md-1">
                <div class="master__heading">
                    <h2 v-if="data" class="agp-normal mb-25px mt-25px" v-html="data.title"></h2>
                </div>
                <div class="master__content master__content--home-review kts-pt-25 kts-pt-mb-20">
                    <Splide :options="review_options" aria-label="Reviews" :has-track="false" class="home-review__review-items lightbox-slider">
                        <SplideTrack>
                            <SplideSlide  v-for="(reviewItem, index) in data.review_items" :key="reviewItem.author" class="splide__slide master-review__review-item" >
                                <div class="master-review__review-details" v-if="reviewItem.review_image">
                                    <div class="master-review__review-details-left">
                                        <div class="master-review__review-image-wrapper">
                                        <a
                                        :data-pswp-width="reviewItem.review_image.width < 500 && reviewItem.review_image.height < 500 ? reviewItem.review_image.width * 100 : reviewItem.review_image.width" 
                                        :data-pswp-height="reviewItem.review_image.height < 500 && reviewItem.review_image.width < 500 ? reviewItem.review_image.height * 100 : reviewItem.review_image.height" 
                                            :href="reviewItem.review_image.url"
                                            class="ps-box">
                                                <img v-if="reviewItem.review_image" 
                                                class="master-review__review-image alt-lazy-img" 
                                                :src="reviewItem.review_image.medium" 
                                                :data-original_src="reviewItem.review_image.url" 
                                                :alt="reviewItem.alt || 'image'"/>
                                        </a>
                                    </div>
                                    </div>
                                    <div class="master-review__review-details-right">
                                        <h4 class="master-review__review-author">{{ reviewItem.author }}</h4>
                                        <span class="master-review__review-date">
                                            <span v-for="n in 5" :key="n" class="star">
                                            <span v-html="n <= reviewItem.review_rate ? redStarSvg : whiteStarSvg"></span>
                                            </span>
                                        </span>
                                        <!-- <p class="master-review__review-text">{{ reviewItem.review_content }}</p> -->
                                        <p class="master-review__review-text" :class="{ truncated: reviewItem.review_content.length > 150 }" v-html="reviewItem.review_content">
                                        </p>
                                        <button
                                            v-if="reviewItem.review_content.length > 150 && !expandedReviews[index]"
                                            class="read-more-btn"
                                            @click="openModal(reviewItem, index)"
                                            >
                                            Read More
                                        </button>
                                    </div>
                                </div>
                            </SplideSlide>
                        </SplideTrack>
                        <div class="splide__arrows splide__arrows--ltr">
                            <button class="splide__arrow splide__arrow--prev" type="button" aria-label="Previous slide" aria-controls="splide01-track">
                                <svg fill="#000000" viewBox="0 0 24.00 24.00" id="right-2" data-name="Flat Line" xmlns="http://www.w3.org/2000/svg" class="icon flat-line" transform="rotate(180)"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" stroke="#CCCCCC" stroke-width="0.048"></g><g id="SVGRepo_iconCarrier"><polyline id="primary" points="7.5 3 16.5 12 7.5 21" style="fill: none; stroke: #000000; stroke-linecap: round; stroke-linejoin: round; stroke-width:2.8160000000000001;"></polyline></g></svg>
                            </button>
                            <button class="splide__arrow splide__arrow--next" type="button" aria-label="Next slide" aria-controls="splide01-track">
                                <svg fill="#000000" viewBox="0 0 24.00 24.00" id="right-2" data-name="Flat Line" xmlns="http://www.w3.org/2000/svg" class="icon flat-line"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" stroke="#CCCCCC" stroke-width="0.048"></g><g id="SVGRepo_iconCarrier"><polyline id="primary" points="7.5 3 16.5 12 7.5 21" style="fill: none; stroke: #000000; stroke-linecap: round; stroke-linejoin: round; stroke-width:2.8160000000000001;"></polyline></g></svg>
                            </button>
                        </div>
                    </Splide>
                    <div v-if="modalVisible" class="modal-overlay" @click.self="closeModal">
                        <div class="modal-content">
                        <button class="modal-close" @click="closeModal">×</button>
                        <Splide :options="modalOptions" ref="modalSplide" aria-label="Review Modal" class="modal-slider lightbox-slider">
                            <!-- <SplideTrack> -->
                                <SplideSlide v-for="(reviewItem, index) in data.review_items" :key="index">
                                    <div class="master-review__review-item">
                                    <div class="master-review__review-details">
                                        <div class="master-review__review-details-left">
                                        <div class="master-review__review-image-wrapper">
                                            <a 
                                            v-if="reviewItem.review_image"
                                            class="ps-box"
                                            :href="reviewItem.review_image.url"
                                            :data-pswp-width="reviewItem.review_image.width < 500 ? reviewItem.review_image.width * 100 : reviewItem.review_image.width" 
                                            :data-pswp-height="reviewItem.review_image.height < 500 ? reviewItem.review_image.height * 100 : reviewItem.review_image.height"  
                                            >
                                                <img
                                                v-if="reviewItem.review_image"
                                                class="master-review__review-image alt-lazy-img"
                                                :src="reviewItem.review_image.medium"
                                                :data-original_src="reviewItem.review_image.url"
                                                :alt="reviewItem.alt || 'image'"
                                                />
                                            </a>
                                        </div>
                                        </div>
                                        <div class="master-review__review-details-right">
                                        <h4 class="master-review__review-author">{{ reviewItem.author }}</h4>
                                        <span class="master-review__review-date">
                                            <span v-for="n in 5" :key="n" class="star">
                                                <span v-html="n <= reviewItem.review_rate ? redStarSvg : whiteStarSvg"></span>
                                            </span>
                                        </span>
                                        <p v-if="reviewItem.review_content.length != 0" class="master-review__review-text" v-html="reviewItem.review_content"></p>
                                        </div>
                                    </div>
                                    </div>
                                </SplideSlide>
                            <!-- </SplideTrack> -->
                        </Splide>
                        </div>
                    </div>
                </div>
            </section>
        </div>
</template>
<script setup lang="ts">
    import {ref, onMounted} from 'vue';
    import { Splide, SplideSlide, SplideTrack } from "@splidejs/vue-splide";
    import { usePhotoSwipe } from '~/composables/usePhotoSwipe';
    const props = defineProps(["data"]);
    const data = props.data;
    const reviewCount = ref(10000);
    const review_options: Object = { 
        arrows: true, 
        pagination: true, 
        perPage: 2, 
        perMove: 1, 
        drag: 'free', 
        gap: '24px', 
        fixedWidth: '40%',
        mediaQuery: 'max', 
        // padding: { right: "15%" },
        breakpoints: { 
            1367: { 
                fixedWidth: '40%',
                perPage: 2,
                perMove: 1,
                gap: '20px', 
            },
            1080: { 
                fixedWidth: '40%',
                perPage: 2, 
                gap: '15px',
                perMove: 1,
            },
            992: { 
                fixedWidth: '40%',
                perPage: 2, 
                gap: '10px', 
                perMove: 1,
            }, 
            767: { 
                fixedWidth: '95%',
                perPage: 1, 
                arrows: false,
                focus: 'center',
                perMove: 1,
                padding: { right: "8%" },
            },
            480: { 
                perPage: 1, 
                fixedWidth: '95%',
                arrows: false,
                focus: 'center',
                perMove: 1,
                padding: { right: "8%" },
            },
        } 
    }
    const expandedReviews = ref<boolean[]>([]);
    const modalVisible = ref(false);
    const modalData = ref<ReviewItem | null>(null);
    const selectedReview = ref([]);
    const modalOptions: Object = {
        type: 'fade',
        perPage: 1,
        arrows: true,
        pagination: false,
        perMove: 1
    };
    const { initWithButtons } = usePhotoSwipe('.lightbox-slider');
    const redStarSvg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 20 19" fill="none">
        <path d="M10 0L12.2451 6.90983H19.5106L13.6327 11.1803L15.8779 18.0902L10 13.8197L4.12215 18.0902L6.36729 11.1803L0.489435 6.90983H7.75486L10 0Z" fill="#C60C46"/>
    </svg>
    `;

    const whiteStarSvg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 20 19" fill="none">
        <path d="M10 1.61804L11.7696 7.06434L11.8819 7.40983H12.2451H17.9717L13.3388 10.7758L13.0449 10.9894L13.1572 11.3348L14.9268 16.7812L10.2939 13.4152L10 13.2016L9.70611 13.4152L5.0732 16.7812L6.84282 11.3348L6.95507 10.9894L6.66118 10.7758L2.02828 7.40983H7.75486H8.11813L8.23039 7.06434L10 1.61804Z" stroke="#C60C46"/>
    </svg>
    `;
    interface ReviewItem {
    author: string;
    review_rate: number;
    review_content: string;
    review_image?: {
        medium: string;
        url: string;
    };
    alt?: string;
    }
    // Methods
    const currentReviewIndex = ref(0);
    const modalSplide = ref<Splide>();
    const openModal = (reviewItem: any, index: number) => {
        // selectedReview.value = [reviewItem]; // Store the selected review
        currentReviewIndex.value = index;   // Set the current index
        modalVisible.value = true;
        document.body.style.overflow = 'hidden';

        // Wait for the modal to render, then navigate the slider
        nextTick(() => {
            initWithButtons()
            modalSplide.value?.go(index);
        });
    };

    const closeModal = () => {
        modalVisible.value = false;
        document.body.style.overflow = 'auto';
    };
    onMounted(() => {
        initWithButtons()
        altLazyIO();
    })
</script>

<style lang="scss">
    @import "@/assets/scss/components/master-template/_master-review.scss";
</style>